import { secondsToTimeString } from 'noddi-util';

/** Format stored Celsius telemetry using the device unit_system preference. */
export const signageFormatCpuTemp = (
  celsius: number,
  unitSystem: 'metric' | 'imperial' | string | null | undefined
): string => {
  if (unitSystem === 'imperial') {
    const f = (celsius * 9) / 5 + 32;
    return `${f.toFixed(1)} °F`;
  }
  return `${celsius.toFixed(1)} °C`;
};

/** MiB value as `1 024 MiB` / `—`. */
export const signageFormatMib = (mb: number | null | undefined): string =>
  mb != null ? `${mb.toLocaleString()} MiB` : '—';

/** Free + optional total disk, e.g. `4 096 / 16 384 MiB`. */
export const signageFormatDisk = (freeMb: number | null | undefined, totalMb: number | null | undefined): string => {
  if (freeMb == null && totalMb == null) {
    return '—';
  }
  if (freeMb != null && totalMb != null) {
    return `${freeMb.toLocaleString()} / ${totalMb.toLocaleString()} MiB free`;
  }
  if (freeMb != null) {
    return `${freeMb.toLocaleString()} MiB free`;
  }
  return `${totalMb!.toLocaleString()} MiB total`;
};

/** Uptime seconds as compact `2d 5h` / `3h 12m` / `45m`. */
export const signageFormatUptime = (uptimeS: number | null | undefined): string => {
  if (uptimeS == null || uptimeS < 0) {
    return '—';
  }
  return secondsToTimeString({ seconds: Math.floor(uptimeS), shortFormat: true, alwaysIncludeSeconds: false });
};
